module.exports = __webpack_public_path__ + "img/table-header.74c08b0c.png";